import { Record } from 'immutable';

const ConfigSentryRecord = Record({
    url: '',
    sentryLevel: '',
    consoleLevel: '',
    whitelistUrls: null,
    includePaths: null,
});

class ConfigSentryModel extends ConfigSentryRecord {}

export default ConfigSentryModel;
